// ── entityType → nav label ────────────────────────────────────────────────────
// Usado por AssistantHistoryPage/AssistantMemoryPage para el filtro por
// módulo (Eduardo, 2026-08-07: "una sola conversación, pero poder filtrar
// por módulo para encontrar cosas más rápido"). Reusa las keys de
// Sidebar.tsx (nav.*) — cero copy nuevo, mismo nombre que ve en el sidebar.

export const ENTITY_TYPE_NAV_KEY: Record<string, string> = {
  project: 'nav.projects',
  lead: 'nav.leads',
  contact: 'nav.contacts',
  report: 'nav.reports',
  task: 'nav.tasks',
  email_message: 'nav.email',
  form: 'nav.forms',
  estimate: 'nav.facturacion',
  invoice: 'nav.facturacion',
  home: 'nav.home',
  settings: 'nav.settings',
};

/** defaultValue = el entityType crudo — mejor mostrar algo reconocible que nada si aparece uno nuevo sin mapear. */
export function entityTypeNavKey(entityType: string): string {
  return ENTITY_TYPE_NAV_KEY[entityType] ?? '';
}
